// extracted by mini-css-extract-plugin
export default {"tabMenu":"statisticTapBar_tabMenu__Dhuua","tabButton":"statisticTapBar_tabButton__tiQ5E","tabActive":"statisticTapBar_tabActive__Qa3c6","main":"statisticTapBar_main__50+Tc"};